export const NetworkTableconstant = {
  NETWORK_TABLE_SAGA: "NETWORK_TABLE_SAGA",
  NETWORK_TABLE_REQUEST: "NETWORK_TABLE_REQUEST",
  NETWORK_TABLE_RESPONSE: "NETWORK_TABLE_RESPONSE",
  NETWORK_TABLE_API: "/networks",

  POST_ADD_CHARGING_NETWORK_SAGA: "POST_ADD_CHARGING_NETWORK_SAGA",
  POST_ADD_CHARGING_NETWORK_REQUEST: "POST_ADD_CHARGING_NETWORK_REQUEST",
  POST_ADD_CHARGING_NETWORK_RESPONSE: "POST_ADD_CHARGING_NETWORK_RESPONSE",
  POST_ADD_CHARGING_NETWORK_API: "/network",

  //enable desable

  ENABLE_DESABLE_CHARGING_NETWORK_SAGA: "ENABLE_DESABLE_CHARGING_NETWORK_SAGA",
  ENABLE_DESABLE_CHARGING_NETWORK_REQUEST:
    "ENABLE_DESABLE_CHARGING_NETWORK_REQUEST",
  ENABLE_DESABLE_CHARGING_NETWORK_RESPONSE:
    "ENABLE_DESABLE_CHARGING_NETWORK_RESPONSE",
  ENABLE_DESABLE_CHARGING_NETWORK_API: "/network",

  UPDATE_CHARGING_NETWORK_SAGA: "UPDATE_CHARGING_NETWORK_SAGA",
  UPDATE_CHARGING_NETWORK_REQUEST: "UPDATE_CHARGING_NETWORK_REQUEST",
  UPDATE_CHARGING_NETWORK_RESPONSE: "UPDATE_CHARGING_NETWORK_RESPONSE",
  UPDATE_CHARGING_NETWORK_API: "/network",

  DELETE_CHARGING_NETWORK_API:'/networks/:id'
};
